import z from "zod";
import { ImageSchema } from "../common";

const DistrictTranslationShape = z.object({
  title: z
    .string()
    .trim()
    .min(3)
    .refine((value) => value.toLowerCase() !== "n/a", "Enter a real translation title"),
  description: z
    .string()
    .trim()
    .min(3)
    .refine((value) => value.toLowerCase() !== "n/a", "Enter real translated content"),
});

const OptionalDistrictTranslationShape = z
  .object({ title: z.string(), description: z.string() })
  .superRefine((value, context) => {
    const title = value.title.trim();
    const description = value.description
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .trim();
    const isEmpty = title === "" && description === "";
    const isComplete =
      title.length >= 3 &&
      title.toLowerCase() !== "n/a" &&
      description.length >= 3 &&
      description.toLowerCase() !== "n/a";

    if (!isEmpty && !isComplete) {
      context.addIssue({ code: "custom", message: "Complete both the title and description, or leave both empty" });
    }
  });

const DistrictTranslationSchema = z.object({
  en: DistrictTranslationShape,
  ar: DistrictTranslationShape,
  tr: OptionalDistrictTranslationShape,
  fa: OptionalDistrictTranslationShape,
});

export const DistrictSectionSchemas = {
  translation: DistrictTranslationSchema,

  item: z.object({
    districtId: z.uuidv7(),
    translations: DistrictTranslationSchema,
  }),

  list: z.object({ id: z.uuidv7() }),

  create: z.object({
    translations: DistrictTranslationSchema,
    image: ImageSchema,
    altText: z.string().nullish(),
  }),

  update: z.object({
    id: z.uuidv7().optional(),
    translations: DistrictTranslationSchema,
    image: ImageSchema,
    altText: z.string().nullish(),
  }),

  delete: z.object({ id: z.uuidv7() }),
};

export type UpdateDistrictSection = z.infer<typeof DistrictSectionSchemas.update>;
